import { useEffect, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import moment from "moment-timezone";
import { useScheduleContext } from "../hooks/context/useScheduleContext";
import { useFilters } from "../../../../utils/hooks/useFilters";
import useApi from "../../../../utils/api";
import { OPEN_SHIFTS_URL, REQUEST_TYPES } from "../components/drawers/Requests/OpenShifts/constants";

export const useOpenShiftsQueryKey = () => {
    const [filters] = useFilters();

    return useMemo(() => [
        OPEN_SHIFTS_URL,
        {
            namespace: "schedule",
            pagination: "false",
            "filter[type][method]": "exact",
            "filter[type][value][]": REQUEST_TYPES,
            "filter[status][method]": "exact",
            "filter[status][value][]": ["pending", "approved"],
            startDate: filters?.mode === "month" ? moment(filters?.from).startOf("week").format("YYYY-MM-DD") : filters?.from,
            endDate: filters?.mode === "month" ? moment(filters?.to).endOf("week").format("YYYY-MM-DD") : filters?.to,
        },
    ], [filters?.mode, filters?.from, filters?.to]);
};

export const useOpenShiftsQuery = () => {
    const { type, dispatch } = useScheduleContext();
    const { authGet } = useApi();
    const queryKey = useOpenShiftsQueryKey();

    const openShiftsQuery = useQuery({
        queryKey,
        queryFn: ({ queryKey, signal }: any) => {
            const [url, params] = queryKey;
            return authGet(url, { params, signal });
        },
        enabled: ["home", "my-profile"].includes(type)
    });

    useEffect(() => {
        if (!openShiftsQuery.isLoading) {
            dispatch({
                type: "open-shifts",
                payload: {
                    openShifts: openShiftsQuery.data?.result ?? [],
                    loadingOpenShifts: openShiftsQuery.isLoading
                }
            });
        }
    }, [openShiftsQuery.isLoading, openShiftsQuery.data, dispatch]);

    return undefined;
}
